import React from 'react';

import Switch, { SwitchProps } from '@material-ui/core/Switch';

interface IProps extends SwitchProps {
  labelNo?: string;
  labelYes?: string;
}

export const YesNoSwitch = ({ labelNo, labelYes, ...props }: IProps) => {
  return (
    <div className="yes-no-switch">
      <div className="yes-no-switch__tag">{labelNo || 'NO'}</div>
      <Switch {...props} color={props.color || 'primary'} className="yes-no-switch__switch" />
      <div className="yes-no-switch__tag">{labelYes || 'YES'}</div>
    </div>
  );
};
